import { helper } from '@ember/component/helper';
import moment from 'moment-timezone';

const DEFAULT_TIMEZONE = 'Europe/Rome';

/**
 * Ritorna il nome del giorno della settimana
 */
function dayName([date, zone = DEFAULT_TIMEZONE]) {
  if (!date) return undefined;
  const momentDate = moment.isMoment(date) ? date : moment(date);
  return momentDate.tz(zone).format('dddd');
}
var dayName$1 = helper(dayName);

export { dayName, dayName$1 as default };
//# sourceMappingURL=day-name.js.map
